import PreprocessAndRenderLatex from "../../../../components/ProcessRenderLatex";
import { preprocessLatex } from "../../../../utils/utlis";
import { normalizeLatexToDoubleDollar } from "../dashboard/teacher/lessons/NewLessons/utils/fileHelpers";

function AnswerInputView({ value }) {

  return (
    <>
      <div className="AssingmentMCQs-short-answer-wrapper">
        <div className="AssingmentMCQs-mock-test-answer-container">
          <div className="options AssignmentMCQs-mock-test-answer-container">
            <div className="option AssignmentMCQs-mock-test-answer-folder">
               <h2 className="AssingmentMCQs-mock-test-title ml-1">Answer</h2>
              <div className="answerinput-textaera-feild !overflow-auto">

                <PreprocessAndRenderLatex
                  // content={preprocessLatex(value || `" "`)}
                  content={normalizeLatexToDoubleDollar(value || `" "`)}
                  wrapperStyle={{
                    // width: "250px",
                    // whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    overflowWrap: "break-word",
                  }}
                  latexInline={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AnswerInputView;
